import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#EBEBEB",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1434CB",
  d: "m24.168 10.785-2.317 10.83h-2.802l2.318-10.83zm11.787 6.993 1.475-4.067.849 4.067zm3.126 3.837h2.591l-2.261-10.83h-2.392c-.538 0-.991.313-1.193.795l-4.203 10.035h2.942l.584-1.617h3.594zm-7.312-3.536c.012-2.858-3.953-3.016-3.925-4.292.008-.39.378-.802 1.188-.908.402-.053 1.507-.093 2.762.485l.492-2.297a7.528 7.528 0 0 0-2.621-.48c-2.769 0-4.718 1.472-4.735 3.58-.017 1.56 1.392 2.43 2.453 2.948 1.092.53 1.459.87 1.454 1.345-.007.727-.87 1.048-1.676 1.06-1.41.023-2.227-.38-2.878-.684l-.508 2.373c.654.301 1.863.562 3.116.576 2.943 0 4.868-1.454 4.878-3.706m-11.604-7.294-4.54 10.83h-2.962l-2.233-8.643c-.136-.532-.254-.727-.666-.951-.673-.366-1.785-.709-2.764-.921l.067-.315h4.767c.607 0 1.154.405 1.292 1.104l1.18 6.268 2.915-7.372z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }